// Official Zita logo — the eye+HUD photograph the user provided.
// Doctrine directive (Feb 2026):
//   • The eye + orange targeting reticle are the brand.
//   • The mechanical/shadow blur around them should FRAME the eye, not
//     cover it. Show more of the eyebrow, eyelid, and skin so the logo
//     reads as "an eye with a targeting scanner" — not as a dark blob.
//   • Optimize for favicon / PWA icon sizes: the raw asset (used in
//     /public/index.html + manifest.json) is the crisp eye with the
//     reticle intact. Inside the app we still feather the image so it
//     dissolves into whatever background it sits on, but with a much
//     wider ("softer") gradient than before so the natural face is
//     revealed by ~40%.
//
// Sits INLINE beside the wordmark, never in a container/box.

export const ZITA_LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_zita-scanner/artifacts/nv8s90j4_file_0000000011ec822fbd504bdfad4a6160.png";

// `feathered` (default) blends into the parent background. Turn off for cases
// where a hard-edged image is needed (e.g. favicon fallback slots).
export const ZitaLogo = ({ size = 96, className = "", feathered = true, variant = "default" }) => {
  // "tight" — used on the dark navy sidebar; iris + HUD only, everything else
  // faded to transparent so nothing shows over the dark background.
  // "default" — used on light backgrounds (landing, auth); wide feather that
  // reveals eyebrow + eyelid + surrounding skin instead of masking them away.
  const isTight = variant === "tight";
  const maskGradient = isTight
    ? "radial-gradient(circle at 50% 50%, #000 40%, rgba(0,0,0,0.85) 58%, rgba(0,0,0,0.4) 74%, transparent 90%)"
    : "radial-gradient(ellipse 60% 55% at 50% 50%, #000 55%, rgba(0,0,0,0.95) 72%, rgba(0,0,0,0.6) 84%, rgba(0,0,0,0.2) 94%, transparent 100%)";

  return (
    <img
      src={ZITA_LOGO_URL}
      alt="Zita"
      width={size}
      height={size}
      draggable={false}
      className={`select-none ${className}`}
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        objectPosition: '72% 45%',
        ...(feathered
          ? { WebkitMaskImage: maskGradient, maskImage: maskGradient }
          : {}),
      }}
    />
  );
};

export const ZitaWordmark = ({ className = "" }) => (
  <span className={`zita-wordmark ${className}`}>Zita</span>
);
